import React, { useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { forgotPasswordService, ResetPasswordDto } from '../../service/forgotpassword.service';
import { Button, Form } from 'react-bootstrap';
import { InputText } from 'primereact/inputtext';

const ResetPasswordPage: React.FC = () => {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const email = params.get('email') ?? '';
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const resetData: ResetPasswordDto = {
                email,
                token,
                newPassword,
            };
            await forgotPasswordService.resetPassword(resetData);
            setMessage('Password reset successful!');
            navigate('/login'); 
        } catch (error) {
            setMessage('Password reset failed.');
        }
    };

    return (
        <div className="content">
            <div className="content-body p-0">
                <div className="login-bg">
                    <div className="container">
                        <div className="d-flex justify-content-end">
                            <form className="login-form" onSubmit={handleSubmit}>
                                <div className="d-flex flex-column gap-2">
                                    <h2 className="login-title">Reset Your Password</h2>
                                    <p>Enter your new password to regain access</p>

                                    <div className="d-flex flex-column gap-2 form-group">
                                        <label htmlFor="newPassword">New Password</label>
                                        <InputText
                                            type="password"
                                            id="newPassword"
                                            placeholder="Enter new password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <Button type="submit" className="p-button-primary w-100">
                                        Reset Password
                                    </Button>

                                    {message && (
                                        <div className="alert alert-info mt-3 text-center" role="alert">
                                            {message}
                                        </div>
                                    )}  

                                    <div className="text-center mt-3">
                                        <span>Back to </span>
                                        <a href="/login" className="text-link" style={{ color: "#1976d2" }}>
                                            Login
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;